export default class MysolvrEntryCardController {
  constructor($stateParams, $sce, handleEntryEdit) {
    'ngInject';

    this.$stateParams = $stateParams;
    this.$sce = $sce;
    this.handleEntryEdit = handleEntryEdit;
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/mysolvr-entries/screens/mysolvr-entry-list/components/mysolvr-entry-card/mysolvr-entry-card.controller.js